import { useState, useEffect } from 'react';
import { buildChilds } from '../utils/richTextUtils';

const useRichTextBuilder = ({ item, itemList }) => {
  const [children, setChildren] = useState(
    item.children || item.items || (itemList && buildChilds(itemList, item))
  );

  useEffect(() => {
    setChildren(item.children || item.items);
    if (!(item.children || item.items) && itemList) {
      setChildren(buildChilds(itemList, item));
    }
  }, [item, itemList]);

  return children;
};

export default useRichTextBuilder;
